import type { SVGProps } from 'react';

const SvgClassN = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_669_26670)'>
      <path
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
        fill='#8F8F8F'
      />
      <path
        d='M15.4062 17.2802C15.0832 17.2802 14.7688 17.1368 14.5571 16.8769L9.68829 10.8932V16.186C9.68829 16.7907 9.19844 17.2802 8.59414 17.2802C7.98985 17.2802 7.5 16.7907 7.5 16.186V7.81412C7.5 7.35082 7.79129 6.93784 8.2277 6.78271C8.66446 6.63103 9.15087 6.76479 9.44285 7.1233L14.3117 13.107V7.81411C14.3117 7.20947 14.8016 6.71997 15.4058 6.71997C16.0101 6.71997 16.5 7.20947 16.5 7.81411V16.186C16.5 16.6493 16.2087 17.0623 15.7723 17.2174C15.6523 17.2595 15.5286 17.2802 15.4062 17.2802Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_669_26670'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassN;
